<template>
  <div class="search-bar-vue">
    <form @submit.prevent="onSearch" class="row search-header form-inline justify-content-center">
      <div class="col-xl-6 col-lg-6 col-md-11 col-sm-12">
        <div class="row form-group mb-2 flex-nowrap justify-content-between">
          <label for="searchGeneral" class="sr-only">{{ i18n.research }}</label>
          <vue-autosuggest
            class="flex-grow-1"
            v-model="searchInput"
            :suggestions="suggestions"
            :input-props="autoSuggestConfig"
            @input="debounceGetSuggestions()"
            @selected="selectSuggestion"
          >
            <template slot-scope="{ suggestion }">
              <span v-html="highlight(searchInput, suggestion.item)" />
            </template>
            <template slot="after-input">
              <button
                v-if="searchInput.length > 0"
                type="button"
                class="clear"
                :aria-label="i18n.abortSearch"
                @click="onClear"
              >
                <span aria-hidden="true">×</span>
              </button>
            </template>
          </vue-autosuggest>
          <button type="submit" class="btn btn-primary ml-2" id="search-button">
            <i class="fa fa-search" aria-hidden="true"></i>
            <span class="hidden-sm">&nbsp;{{ i18n.association.placeholder }}</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { VueAutosuggest } from 'vue-autosuggest';
import { suggestionService } from '@/services/suggestion';

export default {
  components: {
    VueAutosuggest,
  },
  data: function() {
    return {
      i18n: {
        research: this.$t(`research`),
        whatResearch: this.$t(`whatResearch`),
        association: {
          placeholder: this.$t(`association.placeholder`),
        },
      },
      searchInput: this.$store.state.fullText,
      suggestions: [{ data: [] }],
      autoSuggestConfig: {},
    };
  },
  mounted() {
    // debounce search to avoid useless api calls
    this.debounceGetSuggestions = debounce(this.getSuggestions, 200);
    // VueAutoSuggest component's configuration
    this.autoSuggestConfig = {
      id: 'searchGeneral',
      class: 'form-control flex-grow-1',
      placeholder: this.i18n.whatResearch,
      type: 'text',
    };
  },
  methods: {
    onSearch() {
      this.$store.dispatch('setFullText', this.searchInput);
    },
    /**
     * Send a new search with selected suggestion
     */
    selectSuggestion(options) {
      if (options && options.item) {
        this.searchInput = options.item;
      }
      this.onSearch();
    },
    /**
     * Empty suggestions list
     */
    emptySuggestions() {
      this.suggestions = [{ data: [] }];
    },
    /**
     * Get a list of search suggestions
     */
    async getSuggestions() {
      if (this.searchInput !== '') {
        const result = await suggestionService.getSuggestions(this.searchInput); //get suggestions from elastic
        this.emptySuggestions(); //clear previous data
        if (result && result.suggest) {
          //if elastic returned some suggestions, add them to the vue-suggest component to be displayed
          const options = result.suggest.suggestion[0].options;
          if (options.length > 0) {
            options.forEach((option) => {
              this.suggestions[0].data.push(option.text);
            });
          }
        }
      } else {
        this.emptySuggestions();
      }
    },
    /**
     * Highlight the text that's currently typed in the search bar in the suggestion list
     */
    highlight(text, suggestion) {
      const regex = new RegExp(`(${text})`, 'gi');
      return suggestion.replace(regex, '<span class="highlighted">$1</span>');
    },
    /**
     * Clear searchInput and launch empty search
     */
    onClear() {
      this.searchInput = '';
      this.$store.dispatch('setFullText', '');
    },
  },
};
/**
 * Run the function *fn* at most once every *time* ms
 */
function debounce(fn, time) {
  let timeout;
  return function() {
    clearTimeout(timeout);
    timeout = setTimeout(fn, time);
  };
}
</script>
<style lang="less">
@import url('./searchbar.less');
</style>
